<template>
  <div class="universal-order-list">
    <el-card class="box-card">
      <!-- 搜索工具栏 -->
      <div class="search-toolbar">
        <el-form :inline="true" :model="searchForm" class="demo-form-inline">
          <el-form-item label="产品名称">
            <el-autocomplete
              v-model="searchForm.product_name"
              :fetch-suggestions="queryProduct"
              placeholder="产品名称"
              clearable
              style="width: 220px;"
              @select="handleProductSelect"
            >
              <template slot-scope="{ item }">
                <div>{{ item.value }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="产品ID">
            <el-select
              v-model="searchForm.product_id"
              placeholder="请选择产品"
              clearable
              style="width: 220px;"
            >
              <el-option
                v-for="item in productList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="保单号">
            <el-input
              v-model="searchForm.policy_no"
              placeholder="保单号"
              clearable
              style="width: 220px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="保险公司">
            <el-autocomplete
              v-model="searchForm.insurance_type_name"
              :fetch-suggestions="queryInsurance"
              placeholder="保险公司名称"
              clearable
              style="width: 220px;"
              @select="handleInsuranceSelect"
            >
              <template slot-scope="{ item }">
                <div>{{ item.value }}</div>
              </template>
            </el-autocomplete>
          </el-form-item>
          <el-form-item label="投保时间">
            <el-date-picker
              v-model="searchForm.insuranceDateRange"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="timestamp"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="投保状态">
            <el-select
              v-model="searchForm.order_status"
              placeholder="请选择状态"
              clearable
              style="width: 200px;"
            >
              <el-option label="投保资料收集状态" value="1"></el-option>
              <el-option label="投保单照片待上传" value="2"></el-option>
              <el-option label="投保资料待审核" value="4"></el-option>
              <el-option label="订单待支付" value="8"></el-option>
              <el-option label="订单取消状态" value="16"></el-option>
              <el-option label="线下支付待审核" value="32"></el-option>
              <el-option label="线下支付审核失败" value="64"></el-option>
              <el-option label="确认已支付" value="128"></el-option>
              <el-option label="已生效" value="256"></el-option>
              <el-option label="订单已过期" value="512"></el-option>
              <el-option label="理赔中" value="1024"></el-option>
              <el-option label="理赔完成" value="2048"></el-option>
              <el-option label="保单已终止" value="4096"></el-option>
              <el-option label="保单已注销，退款" value="8192"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="被保险人">
            <el-input
              v-model="searchForm.beneficiary"
              placeholder="被保险人"
              clearable
              style="width: 220px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="ID">
            <el-input
              v-model="searchForm.id"
              placeholder="ID"
              clearable
              style="width: 220px;"
            ></el-input>
          </el-form-item>
          <el-form-item label="序号">
            <el-input
              v-model="searchForm.seq_no"
              placeholder="序号"
              clearable
              style="width: 220px;"
            ></el-input>
          </el-form-item>

          <el-form-item label="渠道商">
            <el-autocomplete
              v-model="searchForm.channel"
              :fetch-suggestions="queryChannel"
              placeholder="渠道商"
              clearable
              style="width: 220px;"
              @select="handleChannelSelect"
            >
              <template slot-scope="{ item }">
                <div>
                  {{ item.name || item.realname
                  }}<span v-if="item.alias"> ({{ item.alias }})</span>
                </div>
              </template>
            </el-autocomplete>
          </el-form-item>

          <el-form-item>
            <el-button type="primary" @click="handleSearch">搜索</el-button>
            <el-button @click="handleReset">重置</el-button>
            <el-button type="success" @click="handleExportExcel"
              >导出Excel</el-button
            >
          </el-form-item>
        </el-form>
      </div>

      <!-- 数据表格 -->
      <el-table
        :data="tableData"
        style="width: 100%"
        border
        v-loading="loading"
      >
        <el-table-column
          prop="policyholder"
          label="投保人"
          width="170"
          align="center"
        />
        <el-table-column
          prop="beneficiary"
          label="被保险人"
          width="170"
          align="center"
        />
        <el-table-column
          prop="channel_name"
          label="渠道"
          width="150"
          align="center"
          :formatter="channelFormat"
        />
        <el-table-column
          prop="policy_no"
          label="保单号"
          width="180"
          align="center"
        />
        <el-table-column
          prop="product_name"
          label="产品名称"
          width="180"
          align="center"
        />
        <el-table-column
          prop="insurance_type"
          label="保险公司"
          width="160"
          align="center"
          :formatter="insuranceFormat"
        />
        <el-table-column
          prop="source"
          label="来源"
          width="110"
          align="center"
          :formatter="sourceFormat"
        />
        <el-table-column
          prop="price"
          label="支付金额"
          width="100"
          align="center"
          :formatter="moneyFormat"
        />
        <el-table-column
          prop="pay_price"
          label="实付"
          width="100"
          align="center"
          :formatter="moneyFormat"
        />
        <el-table-column
          prop="insure_type"
          label="投保类型"
          width="100"
          align="center"
          :formatter="insureTypeFormat"
        />
        <el-table-column
          prop="created_at"
          label="投保时间"
          width="160"
          align="center"
          :formatter="dateFormat"
        />
        <el-table-column
          prop="order_status"
          label="保单状态"
          width="130"
          align="center"
          :formatter="statusFormat"
        />
        <el-table-column
          prop="effected_at"
          label="生效时间"
          width="160"
          align="center"
          :formatter="dateFormat"
        />
        <el-table-column
          prop="expired_at"
          label="结束时间"
          width="160"
          align="center"
          :formatter="dateFormat"
        />
        <el-table-column
          prop="seq_no"
          label="序号"
          width="180"
          align="center"
        />
        <el-table-column label="操作" width="280" align="center">
          <template slot-scope="scope">
            <el-button type="text" @click="handleLock(scope.row)"
              >锁定</el-button
            >
            <el-button
              v-if="
                scope.row.order_status > 64 && scope.row.order_status < 1024
              "
              type="text"
              @click="handleRefund(scope.row)"
              >退保</el-button
            >
            <el-button type="text" @click="handleUnlock(scope.row)"
              >解锁</el-button
            >
            <el-button type="text" @click="handleChangeChannel(scope.row)"
              >变更渠道</el-button
            >
          </template>
        </el-table-column>
      </el-table>

      <!-- 分页 -->
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pagination.currentPage"
        :page-sizes="[10, 15, 20, 25]"
        :page-size="pagination.pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="pagination.total"
        style="margin-top: 20px;"
      />
    </el-card>

    <!-- 变更渠道弹窗 -->
    <el-dialog
      title="渠道变更"
      :visible.sync="changeChannelVisible"
      width="400px"
      :close-on-click-modal="false"
    >
      <div style="text-align: center;">
        <el-autocomplete
          v-model="changeChannelForm.channelName"
          :fetch-suggestions="queryChannel"
          placeholder="请输入关键字搜索"
          style="width: 280px;"
          @select="handleChangeChannelSelect"
        >
          <template slot-scope="{ item }">
            <div>
              {{ item.name || item.realname
              }}<span v-if="item.alias"> ({{ item.alias }})</span>
            </div>
          </template>
        </el-autocomplete>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="changeChannelVisible = false">取 消</el-button>
        <el-button
          type="primary"
          @click="confirmChangeChannel"
          :loading="changeChannelLoading"
          >保 存</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import ExportJsonExcel from "js-export-excel";
import {
  getUniversalOrderList,
  lockOrder,
  unlockOrder,
  refundOrder,
  updateOrderChannel
} from "@/api/universal-order";
import { getChannelList } from "@/api/channel";
import {
  getProductList,
  getInsuranceCompanyListForYearInsurance
} from "@/api/product";

export default {
  name: "UniversalOrderList",
  data() {
    return {
      loading: false,
      searchForm: {
        product_name: "",
        product_id: "",
        policy_no: "",
        insurance_type_name: "",
        insurance_type_id: null,
        insuranceDateRange: [],
        order_status: "",
        beneficiary: "",
        id: "",
        seq_no: "",
        channel: ""
      },
      tableData: [],
      pagination: {
        currentPage: 1,
        pageSize: 15,
        total: 0
      },
      channelList: [],
      selectedChannel: null,
      productList: [],
      insuranceList: [],
      selectedProduct: null,
      // 变更渠道弹窗
      changeChannelVisible: false,
      changeChannelLoading: false,
      changeChannelForm: {
        channelName: "",
        channelId: null
      },
      currentRow: null
    };
  },
  created() {
    this.fetchData();
    this.fetchChannelList();
    this.fetchProductList();
    this.fetchInsuranceList();
  },
  methods: {
    async fetchData() {
      this.loading = true;
      try {
        const params = {
          page: this.pagination.currentPage,
          rows: this.pagination.pageSize,
          ...this.buildSearchParams()
        };
        const res = await getUniversalOrderList(params);
        this.tableData = res.rows || [];
        this.pagination.total = res.total || (res.rows ? res.rows.length : 0);
      } catch (e) {
        this.$message.error("获取订单列表失败");
      } finally {
        this.loading = false;
      }
    },
    buildSearchParams() {
      const p = {};
      if (this.searchForm.product_name) p.product_name = this.searchForm.product_name;
      if (this.searchForm.product_id) p.product_id = this.searchForm.product_id;
      if (this.searchForm.policy_no) p.policy_no = this.searchForm.policy_no;
      if (this.searchForm.insurance_type_id) p.insurance_type = this.searchForm.insurance_type_id;
      if (this.searchForm.insuranceDateRange && this.searchForm.insuranceDateRange.length === 2) {
        p.begin_date = Math.floor(this.searchForm.insuranceDateRange[0] / 1000);
        p.end_date = Math.floor(this.searchForm.insuranceDateRange[1] / 1000);
      }
      if (this.searchForm.order_status) p.order_status = this.searchForm.order_status;
      if (this.searchForm.beneficiary) p.beneficiary = this.searchForm.beneficiary;
      if (this.searchForm.id) p.id = this.searchForm.id * 1;
      if (this.searchForm.seq_no) p.seq_no = this.searchForm.seq_no;
      if (this.searchForm.channel && this.selectedChannel) {
        p.channel_id = this.selectedChannel.id;
      }
      return p;
    },
    async fetchChannelList() {
      try {
        const res = await getChannelList();
        this.channelList = res.rows || [];
      } catch (e) {
        // ignore
      }
    },
    async fetchProductList() {
      try {
        const res = await getProductList();
        this.productList = res.rows || [];
      } catch (e) {
        // ignore
      }
    },
    async fetchInsuranceList() {
      try {
        const res = await getInsuranceCompanyListForYearInsurance();
        this.insuranceList = res.rows || [];
      } catch (e) {
        // ignore
      }
    },
    queryChannel(queryString, cb) {
      const results = queryString
        ? this.channelList.filter(item => {
            const name = (item.name || item.realname || "").toLowerCase();
            const alias = (item.alias || "").toLowerCase();
            const q = queryString.toLowerCase();
            return name.includes(q) || alias.includes(q);
          })
        : this.channelList;
      cb(results);
    },
    queryProduct(queryString, cb) {
      const results = queryString
        ? this.productList
            .filter(item => {
              const name = (item.name || "").toLowerCase();
              return name.includes(queryString.toLowerCase());
            })
            .map(item => ({ value: item.name, id: item.id }))
        : this.productList.map(item => ({ value: item.name, id: item.id }));
      cb(results);
    },
    queryInsurance(queryString, cb) {
      const results = queryString
        ? this.insuranceList
            .filter(item => {
              const name = (item.text || "").toLowerCase();
              return name.includes(queryString.toLowerCase());
            })
            .map(item => ({ value: item.text, id: item.id }))
        : this.insuranceList.map(item => ({ value: item.text, id: item.id }));
      cb(results);
    },
    handleProductSelect(item) {
      this.searchForm.product_name = item.value;
    },
    handleInsuranceSelect(item) {
      this.searchForm.insurance_type_name = item.value;
      this.searchForm.insurance_type_id = item.id;
    },
    handleChannelSelect(item) {
      this.selectedChannel = item;
    },
    resetSearchForm() {
      this.searchForm = {
        product_name: "",
        product_id: "",
        policy_no: "",
        insurance_type_name: "",
        insurance_type_id: null,
        insuranceDateRange: [],
        order_status: "",
        beneficiary: "",
        id: "",
        seq_no: "",
        channel: ""
      };
      this.selectedChannel = null;
      this.selectedProduct = null;
    },
    handleSearch() {
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    handleReset() {
      this.resetSearchForm();
      this.pagination.currentPage = 1;
      this.fetchData();
    },
    handleSizeChange(size) {
      this.pagination.pageSize = size;
      this.fetchData();
    },
    handleCurrentChange(page) {
      this.pagination.currentPage = page;
      this.fetchData();
    },
    // 操作按钮
    handleLock(row) {
      if (!row.product_id) {
        this.$message.warning("无效订单");
        return;
      }
      this.$confirm("您确定要锁定吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            const res = await lockOrder({
              order_id: Number(row.id),
              product_id: Number(row.product_id)
            });
            if (res.err_code === 0) {
              this.$message.success("锁定成功");
              this.fetchData();
            } else {
              this.$message.error(res.err_msg || "锁定失败");
            }
          } catch (e) {
            this.$message.error("锁定失败");
          }
        })
        .catch(() => {});
    },
    handleUnlock(row) {
      if (!row.product_id) {
        this.$message.warning("无效订单");
        return;
      }
      this.$confirm("您确定要解锁吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            const res = await unlockOrder({
              order_id: Number(row.id),
              product_id: Number(row.product_id)
            });
            if (res.err_code === 0) {
              this.$message.success("解锁成功");
              this.fetchData();
            } else {
              this.$message.error(res.err_msg || "解锁失败");
            }
          } catch (e) {
            this.$message.error("解锁失败");
          }
        })
        .catch(() => {});
    },
    handleRefund(row) {
      this.$confirm("您确定要退保吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          try {
            const res = await refundOrder({ id: Number(row.id) });
            if (res.err_code === 0) {
              this.$message.success("退保成功");
              this.fetchData();
            } else {
              this.$message.error(res.err_msg || "退保失败");
            }
          } catch (e) {
            this.$message.error("退保失败");
          }
        })
        .catch(() => {});
    },
    handleChangeChannel(row) {
      this.currentRow = row;
      this.changeChannelForm.channelName = "";
      this.changeChannelForm.channelId = null;
      this.changeChannelVisible = true;
    },
    handleChangeChannelSelect(item) {
      this.changeChannelForm.channelId = item.id;
    },
    async confirmChangeChannel() {
      if (!this.changeChannelForm.channelName) {
        this.$message.warning("请选择渠道");
        return;
      }
      if (!this.changeChannelForm.channelId) {
        this.$message.warning("请选择有效的渠道");
        return;
      }
      this.changeChannelLoading = true;
      try {
        const res = await updateOrderChannel({
          order_id: Number(this.currentRow.order_id),
          product_id: Number(this.currentRow.product_id),
          channel_id: this.changeChannelForm.channelId
        });
        if (res.err_code === 0) {
          this.$message.success("渠道变更成功");
          this.changeChannelVisible = false;
          this.fetchData();
        } else {
          this.$message.error(res.err_msg || "变更失败");
        }
      } catch (e) {
        this.$message.error("变更失败");
      } finally {
        this.changeChannelLoading = false;
      }
    },
    async handleExportExcel() {
      try {
        const params = { ...this.buildSearchParams() };
        const res = await getUniversalOrderList(params);
        const rows = res.rows || [];
        if (!rows.length) {
          this.$message.warning("没有数据可导出");
          return;
        }
        const datas = [
          {
            sheetData: rows.map(r => ({
              投保人: r.policyholder,
              被保险人: r.beneficiary,
              渠道: r.channel_name
                ? `${r.channel_name}(${r.alias})`
                : r.alias || "",
              保单号: r.policy_no,
              产品名称: r.product_name,
              保险公司: this.insuranceFormatRaw(r.insurance_type),
              来源: this.sourceFormat(r.source),
              "原价（元）": this.moneyFormatRaw(r.price),
              "实付（元）": this.moneyFormatRaw(r.pay_price),
              投保时间: this.dateFormat(r.created_at),
              保单状态: this.statusFormat(r.order_status),
              生效时间: this.dateFormat(r.effected_at),
              结束时间: this.dateFormat(r.expired_at)
            })),
            sheetName: "sheet",
            sheetHeader: [
              "投保人",
              "被保险人",
              "渠道",
              "保单号",
              "产品名称",
              "保险公司",
              "来源",
              "原价（元）",
              "实付（元）",
              "投保时间",
              "保单状态",
              "生效时间",
              "结束时间"
            ]
          }
        ];
        const ex = new ExportJsonExcel({ fileName: "通用订单", datas });
        ex.saveExcel();
        this.$message.success("导出成功");
      } catch (e) {
        this.$message.error("导出失败");
      }
    },
    // 格式化函数
    channelFormat(row) {
      if (row.channel_name) {
        return `${row.channel_name}(${row.alias})`;
      }
      return row.alias || "";
    },
    insuranceFormat(row) {
      return this.insuranceFormatRaw(row.insurance_type);
    },
    insuranceFormatRaw(value) {
      if (!value) return "";
      const item = this.insuranceList.find(i => i.id === value);
      return item ? item.text : "";
    },
    sourceFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === "object" && arg2 ? arg3 : arg1;
      switch ((v || 0) * 1) {
        case 0:
          return "未知来源";
        case 1:
          return "PC浏览器端投保";
        case 2:
          return "移动浏览器端投保";
        case 4:
          return "iOS端投保";
        case 8:
          return "安卓端投保";
        case 16:
          return "API投保";
        case 32:
          return "微信小程序";
        case 64:
          return "渠道管理后台";
        case 128:
          return "内部管理后台";
        case 256:
          return "移动浏览器端投保-代理人H5";
        case 512:
          return "移动浏览器端投保-代客投保";
        default:
          return "未知来源";
      }
    },
    moneyFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === "object" && arg2 ? arg3 : arg1;
      return this.moneyFormatRaw(v);
    },
    moneyFormatRaw(v) {
      if (v == null) return "";
      return (v / 100).toFixed(2);
    },
    statusFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === "object" && arg2 ? arg3 : arg1;
      if (v == null) return "";
      const map = {
        1: "投保资料收集状态",
        2: "投保单照片待上传",
        4: "投保资料待审核",
        8: "订单待支付",
        16: "订单取消状态",
        32: "线下支付待审核",
        64: "线下支付审核失败",
        128: "确认已支付",
        256: "已生效",
        512: "订单已过期",
        1024: "理赔中",
        2048: "理赔完成",
        4096: "保单已终止",
        8192: "保单已注销，退款"
      };
      return map[v] || "";
    },
    insureTypeFormat(arg1, arg2, arg3) {
      const v = typeof arg1 === "object" && arg2 ? arg3 : arg1;
      if (v === 1) return "客户投保";
      if (v === 2) return "代客投保";
      if (v === 4) return "线下投保";
      return "";
    },
    dateFormat(arg1, arg2, arg3) {
      const raw = typeof arg1 === "object" && arg2 ? arg3 : arg1;
      if (raw === undefined || raw === null || raw === "") return "";
      let ms = raw;
      if (typeof raw === "number") {
        ms = raw < 1e12 ? raw * 1000 : raw;
      } else if (typeof raw === "string") {
        if (/^\d+$/.test(raw)) {
          const num = Number(raw);
          ms = num < 1e12 ? num * 1000 : num;
        } else {
          ms = raw
            .replace(/-/g, "/")
            .replace("T", " ")
            .replace(/Z$/i, "");
        }
      } else {
        return "";
      }
      const d = new Date(ms);
      if (!d || isNaN(d.getTime())) return "";
      if (d.getFullYear() <= 1971) return "";
      const pad = n => (n < 10 ? "0" + n : n);
      return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(
        d.getDate()
      )} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
    }
  }
};
</script>

<style lang="less" scoped>
.universal-order-list {
  .search-toolbar {
    margin-bottom: 12px;
  }
}
</style>
